import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, Col, Row } from "react-bootstrap";
import axios from "axios";
import * as CONST from "../../includes/Constant";
import { Link } from "react-router-dom";
import Loading from 'react-fullscreen-loading';

import Select from 'react-select';
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import useAuthInfo from "../../../hooks/IsAdmin";
import { S_CURRENT_FINACIAL_MONTH, S_FORMAT_CURRENCY_AND_AMOUNT, S_FORMAT_INR_CURRENCY_AND_AMOUNT, SD_CAPITALIZE, SD_FY_MONTHS, SD_INVOICE_STATUS, SD_PROJECT_TYPE } from "../../includes/staticData";
import { setGlobalModal } from "../modal/GlobalModal";
import "../../../assets/css/admin.css";
import '../../../invoice.css';
import ViewInvoice from "../modal/invoice/ViewInvoice";
import ViewClient from "../modal/client/ViewClient";


const ReportInvoicePaymentDetailed = () => {
  const { isAdmin, eDepartmentId } = useAuthInfo();
  const [project, setProject] = useState([]);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [sortColumn, setSortColumn] = useState("inv.id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  /* SEARCH VARIABLES */
  const [financialYears, setFinancialYears] = useState([]);
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);
  const [status, setStatus] = useState('pending');
  const [selectedYear, setSelectedYear] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [searchParams, setSearchParams] = useState({});
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState("");
  const [departmentData, setDepartmentData] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [userDepartment, setUserDepartment] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [arrProjects, setArrProjects] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  useEffect(() => {
    if (!isAdmin && departmentData.length > 0) {
      const matchedDept = departmentData.find((d) => d.value === eDepartmentId);
      if (matchedDept) {
        setUserDepartment(matchedDept);
        setDepartments(matchedDept);
        setSearchParams((prev) => ({
          ...prev,
          department_id: eDepartmentId
        }));
        fetchClientData(eDepartmentId);
      }
    }
  }, [isAdmin, departmentData]);
  useEffect(() => {
    if (searchParams.financialYear) {
      fetchData();
    }
  }, [currentPage, recordsPerPage, sortColumn, sortOrder, searchParams]);

  useEffect(() => {
    const generateFinancialYears = () => {
      const startYear = 2023; // Start from 2024-2025
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      let financialYearsList = [];
      let endYear = currentMonth >= 4 ? currentYear : currentYear - 1;
      // Loop from latest year to startYear to make latest year appear first
      for (let year = endYear; year >= startYear; year--) {
        financialYearsList.push({
          value: `${year}-${year + 1}`,
          label: `${year}-${year + 1}`,
        });
      }
      setFinancialYears(financialYearsList);
      const currentFinancialYear = `${endYear}-${endYear + 1}`;
      const selectedFY = financialYearsList.find(year => year.value === currentFinancialYear);
      setSearchParams((prev) => ({
        ...prev,
        financialYear: currentFinancialYear
      }));
      setSelectedYear(selectedFY);
      setCurrentFinancialYears(selectedFY);
      setSelectedMonth(S_CURRENT_FINACIAL_MONTH());
      setCurrentMonth(S_CURRENT_FINACIAL_MONTH());
    };
    fetchDepartmentData();
    generateFinancialYears();
    fetchAllProjects();
  }, []);

  const fetchDepartmentData = async () => {
    try {
      const departmentResponse = await axios.get(CONST.GET_DEPARTMENT_LIST);
      if (departmentResponse.data.status === 'success') {
        setDepartmentData(departmentResponse.data.data.map(department => ({ value: department.id, label: department.name })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
  };
  /* GET CLIENT PROJECT */
  const fetchClientProjects = async (clientId) => {
    try {
      const response = await axios.post(CONST.GET_CLIENT_PROJECTS, { cid: clientId });
      if (response.data.status === 'success') {
        setArrProjects(response.data.data.map(project => ({ value: project.id, label: project.name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);

    }
  };
  /* GFET ALL PROJECTS */
  const fetchAllProjects = async () => {
    try {
      const response = await axios.get(CONST.GET_PROJECT_LIST);
      if (response.data) {
        setArrProjects(response.data.data.map(project => ({ value: project.project_id, label: project.project_name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);

    }
  };
  const fetchClientData = async (departmentId) => {
    setLoading(true);
    try {
      const clientsResponse = await axios.get(CONST.GET_ALL_CLIENT, {
        params: departmentId ? { department_id: departmentId } : {},
      });
      //const clientsResponse = await axios.get(CONST.GET_ALL_CLIENT);
      if (clientsResponse.data.status === 'success') {
        setClients(clientsResponse.data.data.map(client => ({
          value: client.id,
          label: client.name,
        })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
    setLoading(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(CONST.GET_REPORT_PROJECT_PAYMENT_DETAILED_LIST, {
        params: {
          page: currentPage,
          per_page: recordsPerPage,
          sort_by: sortColumn,
          sort_order: sortOrder,
          client_id: searchParams.client,
          status: searchParams.status,
          invoice_date: searchParams.invoice_date,
          financial_year: searchParams.financialYear,
          department_id: searchParams.department_id,
          invoice_id: searchParams.invoice_id,
          project_id: searchParams.project_id,
          project_type: searchParams.project_type,
          month: selectedMonth?.value,
        }
      });
      if (response.data) {
        setData(response.data.data);
        setTotalRecords(response.data.total);
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {

      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const invoiceStatusOptions = SD_INVOICE_STATUS.map((invoiceStatus) => ({
    label: invoiceStatus.name,
    value: invoiceStatus.code,
  }));

  /* TABLE FUNCTIONS  */

  const columns = [
    {
      dataField: "invoice_number",
      text: "Invoice #",
      sortable: true,
      onSort: () => handleSort("invoice_number"),
      formatter: (cell, row) => {
        const invoice_number = row.invoice_number || '';
        const client_name = row.client?.name || "N/A";
        const invoice_id = row.invoice_id || null;
        return (
          <>
            <Link to="#" className="action"
              onClick={() =>
                setGlobalModal(
                  ViewInvoice,
                  {
                    invoice_id: invoice_id,
                  },
                  {  // Modal Props
                    size: "xl",
                    title: "#" + invoice_number + " - " + client_name
                  }
                )
              }
            >
              {invoice_number}
            </Link >
          </>
        );
      }

    },
    {
      dataField: "client.name",
      text: "Client",
      sortable: true,
      onSort: () => handleSort("client.name"),
      formatter: (cell, row) => {
        const client_name = row.client?.name || "N/A";


        return (
          <>
            <Link to="#" className="action"
              onClick={() =>
                setGlobalModal(
                  ViewClient,
                  {
                    client_id: row.client_id,
                  },
                  {  // Modal Props
                    size: "lg",
                    title: "View Client " + client_name
                  }
                )
              }
            >
              {client_name}
            </Link >

          </>
        );
      }
    },
    {
      dataField: "amount",
      text: "Amount",
      sortable: true,
      onSort: () => handleSort("amount"),
      formatter: (cell, row) => {
        const total_amount = row.amount;
        if (row.client?.country === "IN") {
          return (
            <>  {S_FORMAT_INR_CURRENCY_AND_AMOUNT(total_amount)}</>
          );
        } else {
          return <>{S_FORMAT_CURRENCY_AND_AMOUNT(row.currency || "INR", total_amount || 0)} </>;
        }
      }
    },
    {
      dataField: "exchange_rate",
      text: "EX.Rate",
      sortable: true,
      onSort: () => handleSort("exchange_rate"),
      formatter: (cell, row) => {
        const exchange_rate = row.exchange_rate || 0;
        return (
          <>
            {S_FORMAT_INR_CURRENCY_AND_AMOUNT(exchange_rate)}
          </>
        );

      }
    },
    {
      dataField: "platform_fee",
      text: "Fee",
      sortable: false,
      formatter: (cell, row) => {
        const platform_fee = S_FORMAT_INR_CURRENCY_AND_AMOUNT(row.platform_fee ?? 0);
        return (
          <>
            {platform_fee}

          </>
        );
      }
    },
    {
      dataField: "inr_amount",
      text: "Amount (INR)",
      sortable: true,
      onSort: () => handleSort("inr_amount"),
      formatter: (cell, row) => {
        const inr_amount = row.inr_amount || 0;
        return (
          <>
            {S_FORMAT_INR_CURRENCY_AND_AMOUNT(inr_amount)}
          </>
        );

      }
    },

    {
      dataField: "total_payments",
      text: "Total Received",
      sortable: false,
      formatter: (cell, row) => {
        const actual_amount =
          (parseFloat(row.inr_amount) || 0) + (parseFloat(row.platform_fee) || 0);

        return (
          <>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(actual_amount)}</>
        );
      }
    },
    {
      dataField: "transaction_date",
      text: "Txn. Date",
      sortable: true,
      onSort: () => handleSort("transaction_date"),
      formatter: (cell) => {
        if (!cell) return "";
        const date = new Date(cell);
        return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
      }
    },
    {
      dataField: "transaction_id",
      text: "Txn. ID",
      sortable: true,
      onSort: () => handleSort("transaction_id"),
      formatter: (cell, row) => {
        const transaction_id = (row.transaction_id ?? "-");
        return (
          <>
            {SD_CAPITALIZE(transaction_id)}
          </>
        );
      }
    },
    {
      dataField: "mode",
      text: "Txn. Mode",
      sortable: true,
      onSort: () => handleSort("mode"),
      formatter: (cell, row) => {
        const mode = (row.mode ?? "-");
        return (
          <>
            {SD_CAPITALIZE(mode)}
          </>
        );
      }
    },
    {
      dataField: "status",
      text: "Status",
      sortable: true,
      onSort: () => handleSort("status"),
      formatter: (cell) => {
        const statusItem = SD_INVOICE_STATUS.find(item => item.code === String(cell));
        const statusText = statusItem ? statusItem.name : "Unknown";
        const statusClass = statusItem ? statusItem.color : "bg-secondary";

        return <span className={`badge ${statusClass}`}>{statusText}</span>;
      }
    },



  ];
  /* HANDLES */
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);

  };

  const handleSearch = () => {
    console.log(project)
    setSearchParams({
      client: client ? client.value : "",
      status: status ? status.value : "",
      invoice_date: invoiceDate
        ? invoiceDate.toLocaleDateString('en-CA') // 'YYYY-MM-DD' format
        : "",
      financialYear: selectedYear ? selectedYear.value : "",
      department_id: departments ? departments.value : "",
      invoice_id: invoiceId,
      project_id: project ? project.value : "",
      project_type: projectType ? projectType.value : "",
      month: selectedMonth ? selectedMonth.value : "",
    });
    /* fetchData(); */
  };
  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await axios.post(CONST.EXPORT_INVOICE_PAYMENT_TRANSACTIONS, {
        sort_by: sortColumn,
        sort_order: sortOrder,
        client_id: client ? client.value : "",
        status: status ? status.value : "",
        invoice_date: invoiceDate
          ? invoiceDate.toLocaleDateString('en-CA')
          : "",
        financial_year: selectedYear ? selectedYear.value : "",
        department_id: departments ? departments.value : "",
        invoice_id: invoiceId,
        project_id: project ? project.value : "",
        project_type: searchParams.project_type,
        month: selectedMonth?.value,
      },
        { responseType: 'blob' } // IMPORTANT: this tells axios to handle file as binary
      );

      // Create a blob from the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor to trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'invoices_payment_report.xlsx'); // custom file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };
  const handleReset = () => {
    setLoading(true);
    setClient(null);
    setStatus(null);
    setInvoiceDate(null);
    setSelectedYear(currentFinancialYears);
    setCurrentPage(1);
    setInvoiceId("");
    setProject("");
    setProjectType(null);
    setSelectedMonth("");
    if (!isAdmin) {
      setSearchParams({
        client: "",
        status: "",
        invoice_date: "",
        financialYear: currentFinancialYears ? currentFinancialYears.value : "",
        department_id: departments ? departments.value : "",
        project_id: "",
        project_type: "",
        month: "",
      });
    } else {
      setDepartments(null);
      setSearchParams({
        client: "",
        status: "",
        invoice_date: "",
        financialYear: currentFinancialYears ? currentFinancialYears.value : "",
        department_id: "",
        project_id: "",
        project_type: "",
        month: "",
      });
    }
    setLoading(false);
  };

  const handleClientChange = (selectedOption) => {
    setClient(selectedOption);
  };
  const handleProjectChange = (selectedOption) => {
    console.log(selectedOption)
    setProject(selectedOption);
  };
  const handleDepartmentChange = (selectedOption) => {
    setDepartments(selectedOption);
    fetchClientData(selectedOption?.value)
  };

  const handleStatusChange = (selectedOption) => {
    setStatus(selectedOption);
  };

  const handleDateChange = (date) => {
    setInvoiceDate(date);
  };
  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(order);
  };

  const handlePageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  useEffect(() => {
    if (client) {
      fetchClientProjects(client.value);
    }
  }, [client]);
  /* HANDLE PROJECT TYPE */
  const projectTypeOptions = SD_PROJECT_TYPE.map((projectType) => ({
    label: projectType.name,
    value: projectType.code,
  }));
  const handleProjectType = (selectedOption) => {
    console.log(selectedOption)
    setProjectType(selectedOption);
  };
  /* Month */
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };
  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <div className="container-fluid p-0">
        <div className="row mb-2">
          <Col xs={12} sm={9} md={9} lg={10}  >
            <h1 className="h3 mb-2">Invoice <strong> Report</strong></h1>
          </Col>


        </div>
        <Row className="mb-2">
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={financialYears}
              placeholder="Financial Year..."
              onChange={handleYearChange}
              value={selectedYear}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={SD_FY_MONTHS}
              placeholder="Select Month"
              onChange={handleMonthChange}
              value={selectedMonth}
            />
          </Col>
          {
            (isAdmin) ? (
              <>
                <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
                  <Select
                    options={departmentData}
                    placeholder="Department..."
                    onChange={handleDepartmentChange}
                    value={departments}
                  />
                </Col>
              </>
            ) : ""
          }


          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <input
              type="text"
              className="form-control"
              name="invoice_number"
              onChange={(e) => setInvoiceId(e.target.value)}
              placeholder="Invoice Number"
              value={invoiceId}
            />
          </Col>
          {/* Date Picker (Fixed Placeholder) */}
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={invoiceDate}
              onChange={handleDateChange}
              className="form-control"
              placeholderText="Invoice Date" // Corrected placeholder usage
            />
          </Col>
          {/* Client Dropdown */}
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={clients}
              placeholder="Client.."
              onChange={handleClientChange}
              value={client}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              placeholder="Project..."
              options={arrProjects}
              onChange={handleProjectChange}
              value={project}
            />
          </Col>

          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={projectTypeOptions}
              placeholder="Type..."
              onChange={handleProjectType}
              value={projectType}
            />
          </Col>

          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={invoiceStatusOptions}
              placeholder="Status..."
              onChange={handleStatusChange}
              value={status}
            />
          </Col>

          <Col className="text-right mb-1 mt-2" >
            <Button variant="primary" onClick={handleSearch}>
              <i className='bx bx-search-alt'></i> {" "} Search
            </Button>
            <Button
              variant="secondary"
              onClick={handleReset}
              className="ml-2"
            >
              <i className='bx bx-x'></i> {" "} Reset
            </Button>
            {
              (data && data.length > 0) ? (
                <Button className='ml-1' variant="success" onClick={handleExport}>
                  <i class='bx bx-down-arrow-circle'></i> {" "} Export
                </Button>
              ) : ""
            }
          </Col>
        </Row>

        <div className="row mb-1">

          <div className="card flex-fill pt-3 pb-2">
            <div className="col-12">
              Showing total {totalRecords}
              <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select> records
            </div>

            <Table striped bordered hover className="report-table">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.dataField}
                      onClick={() => col.sortable && handleSort(col.dataField)}
                      style={{ cursor: col.sortable ? "pointer" : "default" }}
                    >
                      {col.text}
                      {col.sortable && (sortColumn === col.dataField ? (sortOrder === "asc" ? " ▲" : " ▼") : "")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {
                  data.length > 0 ? (data.map((item, index) => (
                    <tr key={index}>
                      {columns.map((col) => (
                        <td key={col.dataField} >
                          {col.formatter ? col.formatter(item[col.dataField], item) : item[col.dataField]}
                        </td>
                      ))}
                    </tr>
                  ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className="text-center">
                        No records found.
                      </td>
                    </tr>
                  )
                }

              </tbody>
            </Table>
            <div className="row">
              <div className="col-md-4">
                Showing total {totalRecords}
                <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select> records
              </div>
              <div className="col-md-8 text-right">
                <Pagination className="text-right">
                  {[...Array(Math.ceil(totalRecords / recordsPerPage)).keys()].map((num) => (
                    <Pagination.Item key={num + 1} active={num + 1 === currentPage} onClick={() => setCurrentPage(num + 1)}>
                      {num + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportInvoicePaymentDetailed;
